/** @jsxRuntime automatic */
/** @jsxImportSource react */
import React, { useEffect, useRef, useState } from "react"

export function DashboardInspectorResize({ width, onChange, leftPanelOpen, labels }) {
  const handle = useRef(null)
  const drag = useRef(null)
  const [maximum, setMaximum] = useState(900)
  const [resizing, setResizing] = useState(false)
  useEffect(() => {
    const parent = handle.current?.parentElement
    if (!parent) return undefined
    const measure = () => {
      const available = parent.getBoundingClientRect().width
      if (!available) return
      const palette = parent.querySelector(".datox-react-dashboard__sidebar")?.getBoundingClientRect().width || 0
      const next = Math.max(320, Math.min(900, available - palette - 180))
      setMaximum(next)
      if (width > next) onChange(next)
    }
    measure()
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure)
    observer?.observe(parent)
    return () => observer?.disconnect()
  }, [width, leftPanelOpen, onChange])
  const resize = (value) => onChange(Math.round(Math.min(maximum, Math.max(320, value))))
  const stop = () => {
    drag.current = null
    setResizing(false)
  }
  return (
    <div
      ref={handle}
      className="datox-react-dashboard__inspector-resize"
      role="separator"
      tabIndex={0}
      aria-label={labels.resizeEditor}
      title={labels.resizeEditorHelp}
      aria-orientation="vertical"
      aria-valuemin={320}
      aria-valuemax={maximum}
      aria-valuenow={width}
      data-resizing={resizing || undefined}
      onPointerDown={(event) => {
        if (event.button !== 0) return
        event.preventDefault()
        event.stopPropagation()
        event.currentTarget.focus()
        event.currentTarget.setPointerCapture?.(event.pointerId)
        drag.current = { x: event.clientX, width }
        setResizing(true)
      }}
      onPointerMove={(event) => {
        if (drag.current) resize(drag.current.width + drag.current.x - event.clientX)
      }}
      onPointerUp={(event) => {
        event.currentTarget.releasePointerCapture?.(event.pointerId)
        stop()
      }}
      onPointerCancel={stop}
      onLostPointerCapture={stop}
      onDoubleClick={() => resize(320)}
      onKeyDown={(event) => {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return
        event.preventDefault()
        event.stopPropagation()
        resize(
          event.key === "Home" ? 320 : event.key === "End" ? maximum : width + (event.key === "ArrowLeft" ? 32 : -32),
        )
      }}
    >
      <span aria-hidden="true" />
    </div>
  )
}
